import React from 'react';
import ReceiptsDashboard from '../components/ReceiptsDashboard';
import './PagosPage.css';

const PagosPage = () => {
  return (
    <div className="pagos-page-wrapper">
      <ReceiptsDashboard isOpen={true} onClose={() => {}} standalone={true} />
    </div>
  );
};

export default PagosPage;
